import { __ } from '@wordpress/i18n';
export const getCarrierOptions = ( allCarriers, isRequired = false ) => {
	const carrierOptions = [ {
		label: ! isRequired ? __( 'Select a carrier ( optional )', 'yith-woocommerce-delivery-date' ) : __( 'Select a carrier', 'yith-woocommerce-delivery-date' ),
		value: '-1',
	} ];
	const options = allCarriers
		? Object.keys( allCarriers ).map( ( index ) => {
			const carrierLabel = allCarriers[ index ];
			return {
				label: carrierLabel,
				value: index,
			};
		} )
		: [];

	return options.length > 0 ? [ ...carrierOptions, ...options ] : options;
};

export const getAvailableDates = ( availableDates ) => {
	return availableDates
		? availableDates.map( ( date ) => {
			return new Date( date * 1000 ).toDateString();
		} )
		: [];
};

export const getMinDate = ( availableDates ) => {
	return availableDates
		? new Date( availableDates[ 0 ] * 1000 )
		: null;
};
export const getMaxDate = ( availableDates ) => {
	return availableDates
		? new Date( availableDates[ availableDates.length - 1 ] * 1000 )
		: null;
};

export const getTimeSlotOptions = ( allSlots, isRequired = false ) => {
	const slots = Object.keys( allSlots ).map( ( index ) => {
		const slot = allSlots[ index ];
		return {
			label: slot.label,
			value: index,
			priceHtml: slot.priceHtml,
			feeValue: slot.feeValue,
			feeName: slot.feeName,
			isTaxable: slot.isTaxable,
		};
	} );

	const defaultOpt = [ {
		label: ! isRequired ? __( 'Select a time slot ( optional )', 'yith-woocommerce-delivery-date' ) : __( 'Select a time slot', 'yith-woocommerce-delivery-date' ),
		value: '-1',
	} ];
	return slots.length > 0 ? [ ...defaultOpt, ...slots ] : slots;
};

/**
 * Given some block attributes, gets attributes from the dataset or uses defaults.
 *
 * @param {Object} blockAttributes Object containing block attributes.
 * @param {Array}  rawAttributes   Dataset from DOM.
 * @return {Array} Array of parsed attributes.
 */
export const getValidBlockAttributes = ( blockAttributes, rawAttributes ) => {
	const attributes = [];

	Object.keys( blockAttributes ).forEach( ( key ) => {
		if ( typeof rawAttributes[ key ] !== 'undefined' ) {
			switch ( blockAttributes[ key ].type ) {
				case 'boolean':
					attributes[ key ] =
						rawAttributes[ key ] !== 'false' &&
						rawAttributes[ key ] !== false;
					break;
				case 'number':
					attributes[ key ] = parseInt( rawAttributes[ key ], 10 );
					break;
				case 'array':
				case 'object':
					attributes[ key ] = JSON.parse( rawAttributes[ key ] );
					break;
				default:
					attributes[ key ] = rawAttributes[ key ];
					break;
			}
		} else {
			attributes[ key ] = blockAttributes[ key ].default;
		}
	} );

	return attributes;
};

export default getValidBlockAttributes;

